import { GridSize } from '@mui/material';

export type TDropItem = {
  value: string;
  label: string;
};

export enum FormFieldType {
  SELECT = 'SELECT',
  TEXT = 'TEXT',
  DATE = 'DATE',
  EMAIL = 'EMAIL',
  STATIC = 'STATIC',
  NUMBER = 'NUMBER',
  PASSWORD = 'PASSWORD',
  RADIO_GROUP = 'RADIO_GROUP',
  MULTI_SELECT = 'MULTI_SELECT',
  MULTI_INSTANCE = 'MULTI_INSTANCE',
  SINGLE_INSTANCE = 'SINGLE_INSTANCE',
  CHECK_GROUP = 'CHECK_GROUP',
  FILE_UPLOAD = 'FILE_UPLOAD',
  LOCAL_FILE_UPLOAD = 'LOCAL_FILE_UPLOAD',
}

export type TCustomFieldProperty = {
  path: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  variant?: 'standard' | 'outlined';
  type?: FormFieldType;
  options?: TDropItem[];
  xs?: GridSize;
  lg?: GridSize;
  validator?: any;
  step?: any;
};

export type TCustomField = {
  label: string;
  comment?: string;
  maxEntries?: number;
  maxLength?: number;
  helperText?: string;
  path: string;
  disabled?: boolean;
  type?: FormFieldType;
  placeholder?: string;
  shrink?: boolean;
  options?: TDropItem[];
  readOnly?: boolean;
  multiple?: boolean;
  required?: boolean;
  variant?: 'standard' | 'outlined';
  validator?: any;
  properties?: TCustomFieldProperty[];
  limit?: number;
  addButton?: string;
  deleteButton?: string;
  instanceLabel?: string;
  xs?: GridSize;
  lg?: GridSize;
  step?: any;

  optionsLayout?: {
    xs?: GridSize;
    md?: GridSize;
    lg?: GridSize;
    xl?: GridSize;
  };

  acceptFileTypes?: string;
  uploadButton?: string;

  render?: (value: any) => any;
  renderCondition?: (values: any) => boolean;
};

export type TFormGroup = {
  isExpandable?: boolean;
  fields: TCustomField[];
  groupName: string;
  showGroupName?: boolean;
  renderCondition?: (values: any) => boolean;
};

export type TGroupedFormDef = {
  title: string;
  groups: TFormGroup[];
};

export type TCommonFieldProps = {
  label?: string;
  readOnly?: boolean;
  required?: boolean;
  showManualError?: boolean;
  validator?: any;
};
